import { useState, useEffect } from 'react';
import { VisualFieldSetup, VisualFieldTest, VisualFieldResults } from '..';
import ExamEyeSetup from '../exams/ExamEyeSetup';
import { useTestContext } from '../../../context/testContext';
import { usePostMessage } from '../../../context/messageContext';
import { StepBody, useTestStepSync } from '../testScreenKit';

const VisualField = ({ setTitle, setActiveTab }) => {
  const { testData, updateTestData } = useTestContext();
  const [step, setStep] = useState('eyeSetup');
  const postMessage = usePostMessage();
  useTestStepSync(testData.testKey, step);

  useEffect(() => {
    switch (step) {
      case 'eyeSetup':
        updateTestData({ visualFieldTwoResults: {} });
        return setTitle('Visual Field Test');
      case 'rightEyeSetup':
        return setTitle('Visual Field Test - Right Eye');
      case 'leftEyeSetup':
        if (testData.testRightEye) updateTestData({ testInProgress: true });
        return setTitle('Visual Field Test - Left Eye');
      case 'bothEyesSetup':
        return setTitle('Visual Field Test - Binocular');
      case 'rightEyeTest':
        return setTitle('Visual Field Test - Right Eye');
      case 'leftEyeTest':
        return setTitle('Visual Field Test - Left Eye');
      case 'bothEyesTest':
        return setTitle('Visual Field Test - Binocular');
      case 'results':
        return setTitle('Visual Field Test - Results');
      default:
        break;
    }
  }, [updateTestData, step, testData.testRightEye, setTitle]);

  const updateStep = (selectedStep) => {
    if (selectedStep === 'results') postMessage({ type: 'endOfTest' });
    if (selectedStep.endsWith('Setup')) postMessage({ type: 'holding' });
    if (selectedStep.endsWith('Test')) postMessage({ type: 'visualFieldTwo', content: {} });
    return setStep(selectedStep);
  };

  const renderSwitch = () => {
    switch (step) {
      case 'eyeSetup':
        return <ExamEyeSetup updateStep={updateStep} />;
      case 'bothEyesSetup':
      case 'rightEyeSetup':
      case 'leftEyeSetup':
        return <VisualFieldSetup eyeTested={step.split('S')[0]} updateStep={updateStep} />;
      case 'rightEyeTest':
      case 'leftEyeTest':
      case 'bothEyesTest':
        return <VisualFieldTest eyeTested={step.split('Test')[0]} updateStep={updateStep} />;
      case 'results':
        return <VisualFieldResults localResults={testData.visualFieldTwoResults} setActiveTab={setActiveTab} updateStep={updateStep} />;
      default:
        return;
    }
  };

  return (
    <StepBody data-testid='visual-field' data-step={step}>
      {renderSwitch()}
    </StepBody>
  );
};

export default VisualField;
